var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/65ba8f5c969b48306660ded5a1b4283b.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/88e22d1125e1a87b3ee78b45e9de70c7.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d454104e6625224f4f715f6b9129decd.js').default;
var scope_3 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e3638cf48c1b451161a74b8abffe1b0a.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    